import { useMemo } from "react";
import { useFetch } from "../useFetch";
import { PagedResultDto } from "../../types/api/PagedResultDto";
import { Vehicle } from "../../types/api/guide/vehicle.types";
import { vehicleService } from "../../services/guide/vehicle-service";

export const useFetchPagedVehicle = (page: number, pageSize: number, name?: string) => {
    const params = useMemo(() => [page, pageSize, name] as const, [page, pageSize, name]);
    return useFetch<PagedResultDto<Vehicle>>(vehicleService.getPaged, params as unknown as [number, number, string?]);
};
